/**
 * Created by koppany.kiss on 2017. 06. 12..
 */

export default function (app) {
	app.directive('copyText', function () {

		return {
			restrict: 'A',
			link: function (scope, element) {
				element.bind('click', function () {
					this.select();
					try {
						document.execCommand('copy');
						window.getSelection().removeAllRanges();
					} catch (err) {
						// TODO: error logolása
					}
				});
			}
		};
	});
};
